module.exports = __webpack_public_path__ + "static/media/ic_phone.71f17a81.jpg";